<template>
  <base-cell
    class="client-cell"
    condensed
    @click="onClick"
  >
    <template v-if="selectable">
      <base-icon
        class="mx-3"
        :icon="checkedIds.includes(value.pk) ? 'checked': 'unchecked'"
      />
    </template>

    <base-avatar
      :size="44"
      :username="`${ item.first_name } ${ item.last_name }`"
      :img="item.first_name ? null : '/img/person.png'"
    />
    <base-text
      class="client-cell__name"
      trim
    >
      {{ item.display_name_array[0] | truncate(35) }}
    </base-text>
    <div class="d-flex justify-content-center flex-column position-relative">
      <base-text
        class="ml-2 client-cell__email"
        size="s"
      >
        {{ item.email }}
      </base-text>
    </div>
    <!-- <div class="d-flex justify-content-center flex-column position-relative">
      <base-text
        v-if="item.unsubscribed"
        class="client-cell__unsub"
      >
        Opted-out of all
      </base-text>
    </div> -->
  </base-cell>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';
import responsive from '@/components/mixins/responsive';
import whichbrowser from '@/components/mixins/whichbrowser';
import integrable from '@/components/mixins/integrable';

export default {
  name: 'GroupClientCell',
  mixins: [whichbrowser, integrable, responsive, utilsMixin],
  model: {
    prop: 'checked',
    event: 'input',
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    hideProducts: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    checked: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    checkedIds() {
      return this.checked.map((client) => client.pk);
    },
    externalIdOnly() {
      return this.useFeature('customer_external_id_only');
    },
  },
  methods: {
    products(item) {
      if (!item.cart) {
        return [];
      }

      const productLengthLimit = this.responsive.lg ? 6 : 3;

      return item.cart.products.slice(0, productLengthLimit);
    },
    onClick() {
      if (this.selectable) {
        this.$emit('click', this);
      } else {
        this.$emit('click', this.item);
      }
    },
    select() {
      if (this.checkedIds.includes(this.value.pk)) {
        this.checked.splice(this.checkedIds.indexOf(this.value.pk), 1);
      } else {
        this.checked.push(this.value);
      }
    },
    productClicked(productUrl) {
      this.$mixpanel.track('product_clicked', {
        account_id: this.$store.state.account.user.user.email,
        location: '/clients',
        url: productUrl,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.client-cell {
  min-height: 59.4px;
  background-color: inherit !important;
  border-bottom: 0.25px solid $black;
  border-top: none !important;

  &__name {
    min-width: 190px;
    margin-left: 1rem;
    font-size: 0.875rem;
    font-family: $font-family-sans-serif-light;
    letter-spacing: -0.006px;
    @media (min-width: map-get($breakpoints,'md')) {
      min-width: 240px;
    }
  }
  &__email {
    font-size: 14px;
    font-family: $font-family-sans-serif-light;
    letter-spacing: -0.006px;
  }
  &__products {
    min-height: 50px;
    margin-left: auto;
    &::v-deep .activity__img{
      margin-right: 1px;
    }
  }
  &__sep {
    border-top: solid 0.25px white;
    margin: 0.3rem 0;
    &.is-chrome {
      box-shadow: 0 -0.25px 0 white;
      min-height: 1px;
      border: none;
    }
  }
  &__unsub {
    margin: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 100%;
    color: #b5afaf;
    font-size: 10px;
    padding: 3px;
    text-align: center;
  }
}
hr {
  margin: 0.2rem 0;
  border-color: rgba(white, 0.2);
}
</style>
